// frontend/src/pages/PermissionDenied.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Button,
  Paper,
  Container } from
'@mui/material';
import {
  Lock as LockIcon,
  ArrowBack as ArrowBackIcon } from
'@mui/icons-material';import { useThemeSettings } from "../contexts/ThemeContext";

const PermissionDenied = () => {const { t } = useThemeSettings();
  const navigate = useNavigate();

  return (
    <Container maxWidth="md" sx={{ mt: 8 }} className="page-transition-enter">
      <Paper
        elevation={3}
        className="card-animated card-enter"
        sx={{
          p: 4,
          textAlign: 'center',
          borderRadius: 2,
          borderTop: 5,
          borderColor: 'error.main'
        }}>
        
        <LockIcon color="error" className="pulse" sx={{ fontSize: 64, mb: 2 }} />

        <Typography variant="h4" component="h1" className="slide-down" gutterBottom>{t ? t("PermissionDenied.permission_denied") : "Permission Denied"}

        </Typography>
        
        <Typography variant="body1" paragraph color="text.secondary">{t ? t("PermissionDenied.you_dont_have_necessary_permissions") : "You don't have the necessary permissions to access this page. \n          If you believe you should have access, please contact your administrator."}


        </Typography>
        
        <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center', gap: 2 }}>
          <Button
            variant="outlined"
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate('/dashboard')}>{t ? t("PermissionDenied.return_dashboard") : "Return to Dashboard"}


          </Button>
        </Box>
        
        <Typography variant="caption" display="block" sx={{ mt: 4, color: 'text.secondary' }}>{t ? t("PermissionDenied.error_code_permissiondenied") : "Error Code: PERMISSION_DENIED"}

        </Typography>
      </Paper>
    </Container>);

};

export default PermissionDenied;